import React, { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";

/**
 * Polished invoice header — "Zylker"-style layout.
 *  - Logo on the left (rounded corner badge if present)
 *  - Big "INVOICE" word + invoice number on the right
 *  - Business name in primary brand color below the logo, address muted
 */
export default function InvoicePrintHeader({ inv }) {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)).catch(() => {}); }, []);

  const biz = s?.business_name || "Catskills Pool Supplies LLC";

  return (
    <div style={{ marginBottom: 36 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 24 }}>
        {/* LEFT — Logo + business identity */}
        <div style={{ flex: 1, minWidth: 0 }}>
          {s?.logo_data_url ? (
            <img
              src={s.logo_data_url}
              alt="logo"
              style={{
                height: 72,
                width: "auto",
                maxWidth: 200,
                objectFit: "contain",
                marginBottom: 18,
                display: "block",
              }}
            />
          ) : (
            <div style={{
              fontFamily: "'IBM Plex Serif',Georgia,serif",
              fontWeight: 900, fontSize: 36, color: "#60A5FA",
              letterSpacing: "-0.04em", marginBottom: 18,
            }}>
              {(biz[0] || "C").toUpperCase()}
            </div>
          )}
          <div style={{
            fontFamily: "'IBM Plex Serif','Georgia',serif",
            fontSize: 22,
            fontWeight: 800,
            letterSpacing: "-0.02em",
            color: "#60A5FA",
            lineHeight: 1.15,
          }}>
            {biz}
          </div>
          {s?.business_address && (
            <div style={{ fontSize: 12, color: "#64748B", marginTop: 8, lineHeight: 1.6, maxWidth: 320 }}>
              {s.business_address.split(",").map((line, i) => (
                <div key={`bizaddr-${i}-${line.trim()}`}>{line.trim()}</div>
              ))}
            </div>
          )}
          {s?.business_phone && (
            <div style={{ fontSize: 12, color: "#64748B", lineHeight: 1.6 }}>{s.business_phone}</div>
          )}
        </div>

        {/* RIGHT — INVOICE word + number + balance due */}
        <div style={{ textAlign: "right", flexShrink: 0, minWidth: 220 }}>
          <div style={{
            fontFamily: "'IBM Plex Serif','Georgia',serif",
            fontSize: 38,
            fontWeight: 900,
            letterSpacing: "0.04em",
            color: "#60A5FA",
            lineHeight: 1,
          }}>INVOICE</div>
          <div style={{
            fontSize: 11,
            color: "#64748B",
            marginTop: 6,
            fontFamily: "'JetBrains Mono',monospace",
          }}># {inv?.number}</div>
        </div>
      </div>
    </div>
  );
}
